// @flow
import React from 'react';

export const LineBreak = () => <br />;
